
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.406 16c.198 0 .402-.059.612-.176l5.766-3.272c.338-.196.593-.417.767-.664.174-.247.26-.632.26-1.155v-5.81c0-.382-.072-.697-.216-.947-.144-.25-.37-.464-.678-.645L8.723.38C8.283.127 7.845 0 7.409 0c-.435 0-.875.127-1.32.381L.902 3.331c-.313.18-.541.396-.686.645-.144.25-.216.565-.216.947v5.81c0 .523.088.908.264 1.155.176.247.43.468.763.664l5.774 3.272c.205.117.407.176.605.176zm3.451-10.557L5.172 2.23l1.408-.8c.558-.317 1.11-.317 1.658 0l4.835 2.759-2.216 1.254zM7.41 7.395L1.746 4.189 4.013 2.89l5.663 3.221L7.41 7.395zm-.58 7.116l-5.142-2.927c-.215-.123-.364-.251-.447-.386a.94.94 0 01-.125-.502V5.157L6.83 8.422v6.089zm1.153 0V8.42l5.715-3.264v5.539a.94.94 0 01-.125.502c-.083.135-.23.263-.44.386l-5.15 2.927z","fill":"#108999"}})])
          )
        }
      }
    